module.exports = __webpack_public_path__ + "img/thumbnail_GrizzlyBear_j_albino.fffa83ba.png";